import * as Yup from "yup";
import checkout from "layouts/class/components/class-details/schemas/classForm";

const {
  formField: { className, classLevel, organization, subOrganization },
} = checkout;

export default {
  validation: Yup.object().shape({
    [className.name]: Yup.string().required(className.errorMsg),
    [classLevel.name]: Yup.object().nullable().required(classLevel.errorMsg),
    [organization.name]: Yup.object().nullable().required(organization.errorMsg),
    [subOrganization.name]: Yup.object().nullable().required(subOrganization.errorMsg),
  }),
};
